/** React text rendering only: message content never becomes HTML. */
export default function WhatsAppMessagePreview({
  message,
  raw = false,
}: {
  message: string;
  raw?: boolean;
}) {
  function line(text: string) {
    return text.split(/(_\*[^*\n]+\*_|\*[^*\n]+\*|_[^_\n]+_)/g).map((part, index) =>
      part.startsWith('_*') && part.endsWith('*_') ? (
        <strong key={index} className="font-semibold">
          <em>{part.slice(2, -2)}</em>
        </strong>
      ) : part.startsWith('*') && part.endsWith('*') ? (
        <strong key={index} className="font-semibold">
          {part.slice(1, -1)}
        </strong>
      ) : part.startsWith('_') && part.endsWith('_') ? (
        <em key={index} className="text-emerald-950/70 dark:text-emerald-100/70">
          {part.slice(1, -1)}
        </em>
      ) : (
        part
      ),
    );
  }
  return (
    <div
      aria-label="WhatsApp message preview"
      className="rounded-2xl border border-emerald-700/15 bg-emerald-50/60 p-3 sm:p-4 dark:bg-emerald-950/20"
    >
      <div className="mb-3 flex items-center gap-2 text-[11px] font-medium text-muted-foreground">
        <span className="h-2 w-2 rounded-full bg-emerald-500" />
        Message preview
      </div>
      <div className="select-text rounded-2xl rounded-tr-sm bg-white p-4 text-[13px] leading-[1.65] text-emerald-950 shadow-sm [overflow-wrap:anywhere] sm:text-sm dark:bg-emerald-900/50 dark:text-emerald-50">
        {raw ? (
          <div className="whitespace-pre-wrap">{message}</div>
        ) : (
          message.split('\n').map((text, index) => (
            <div key={index} className="min-h-[0.65rem] whitespace-pre-wrap">
              {line(text)}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
